import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {JalaliMomentDateAdapter} from '../widget/mat-core/jalali-moment-date-adapter';
import {PomodoroRepository} from '../Models/PomodoroRepository';
import * as moment from 'jalali-moment';
import {Reminder} from '../Models/reminder.model';
import {ReminderService} from '../services/reminder.service';
import {MatInput} from '@angular/material/input';
import {fadeInOnEnterAnimation, fadeOutOnLeaveAnimation} from 'angular-animations';
import {Router} from '@angular/router';
import {UserService} from '../services/user.service';
import {MatDialog} from '@angular/material/dialog';
import {ReminderSetMobileComponent} from '../dialogs/reminder-set-mobile/reminder-set-mobile.component';
import {SnackBarService} from '../services/snack-bar.service';


@Component({
  selector: 'app-reminder',
  templateUrl: './reminder.component.html',
  styleUrls: ['./reminder.component.css'],
  animations: [
    fadeInOnEnterAnimation(),
    fadeOutOnLeaveAnimation()
  ]
})
export class ReminderComponent implements OnInit {
  @ViewChild('fromInput', {
    read: MatInput
  }) fromInput: MatInput;
  public pomodoroRepository: PomodoroRepository;
  public proVersion = 'false';
  public isPremium;
  public reminder = new Reminder();
  public required: boolean = !1;
  public time = new Date();
  public reminders = [];
  public sendReminder = {
    send_date: '',
    content: ''
  };
  public editContent = '';
  public editMode = false;
  public datePickerData: unknown;
  public helperProp: any;
  public haveMobile;
  public archiveNumber;
  public leftMessageNumber;
  public adapter: JalaliMomentDateAdapter | undefined;

  startDate = moment('2017-01-01', 'YYYY-MM-DD');
  minDate = moment('2017-10-02', 'YYYY-MM-DD');
  maxDate = moment('1396-07-29', 'jYYYY-jMM-jDD');
  jsonDate = '2017-10-19T12:19:48.817';
  weeksInJalali = [
    {enName: 'Saturday', faName: 'شنبه', faAbbr: 'ش', order: 0},
    {enName: 'Sunday', faName: 'یکشنبه', faAbbr: 'ی', order: 1},
    {enName: 'Monday', faName: 'دوشنبه', faAbbr: 'د', order: 2},
    {enName: 'Tuesday', faName: 'سه شنبه', faAbbr: 'س', order: 3},
    {enName: 'Wednesday', faName: 'چهارشنبه', faAbbr: 'چ', order: 4},
    {enName: 'Thursday', faName: 'پنجشنبه', faAbbr: 'پ', order: 5},
    {enName: 'Friday', faName: 'جمعه', faAbbr: 'ج', order: 6}
  ];

  monthsInJalali = [
    {faName: 'فروردین', order: 0},
    {faName: 'اردیبهشت', order: 1},
    {faName: 'خرداد', order: 2},
    {faName: 'تیر', order: 3},
    {faName: 'مرداد', order: 4},
    {faName: 'شهریور', order: 5},
    {faName: 'مهر', order: 6},
    {faName: 'آبان', order: 7},
    {faName: 'آذر', order: 8},
    {faName: 'دی', order: 9},
    {faName: 'بهمن', order: 10},
    {faName: 'اسفند', order: 11}
  ];
  myFilter = (d: moment.Moment): boolean => {
    const day: number = d.day();
    // Prevent Thursday and Friday from being selected.
    return day !== 5 && day !== 4;
  }

  constructor(private injector: Injector,
              private reminderService: ReminderService,
              private router: Router,
              private userService: UserService,
              public dialog: MatDialog,
              private snackBar: SnackBarService) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
  }

  ngOnInit(): void {
    this.isPremium = localStorage.getItem('isPremium');
    this.proVersion = this.isPremium;
    this.adapter = new JalaliMomentDateAdapter();
    this.getListOfReminder();
    this.getCurrentUser();
  }

  onInput(event: MatDatepickerInputEvent<unknown, unknown | null>): any {
    this.datePickerData = event.value;
  }

  onChange(event: MatDatepickerInputEvent<unknown, unknown | null>): any {
    // @ts-ignore
    const x = moment(event.value).format('jYYYY-jMM-jDD');
    localStorage.setItem('reminder-date', x);
  }

  setText(text: any): any {
    localStorage.setItem('reminder-text', text);
  }

  change($event: Date): any {
    this.time = $event;
  }

  close(): any {
  }

  switchShowTimer(): any {
    this.pomodoroRepository.showTimer = !this.pomodoroRepository.showTimer;
  }

  setReminder(): any {
  if (!this.haveMobile){
    this.openMobileDialog();
  } else {
    if (!localStorage.getItem('reminder-date') && !localStorage.getItem('reminder-time') && !localStorage.getItem('reminder-text')) {
      return;
    }
    const reminder = new Reminder();
    reminder.date = localStorage.getItem('reminder-date');
    reminder.time = localStorage.getItem('reminder-time');
    reminder.text = localStorage.getItem('reminder-text');
    this.sendReminder.send_date = reminder.date.concat(' ' + reminder.time.toString());
    this.sendReminder.content = reminder.text;
    this.reminderService.storeReminder(this.sendReminder).subscribe(
      (data) => {
        this.getListOfReminder();
        console.log(data);
        this.snackBar.showSnackBar('پیامک یادآور با موفقیت به لیست اضافه شد.', 'green-snackbar');
      }, (err) => {
        const errorFromServer = err.error;
        if (Object.keys(errorFromServer)[0] === 'content'){
          this.snackBar.showSnackBar( errorFromServer.content[0], 'red-snackbar');
        }
        if (Object.keys(errorFromServer)[0] === 'send_date'){
          this.snackBar.showSnackBar( errorFromServer.send_date[0], 'red-snackbar');
        }
      }
    );
    localStorage.removeItem('reminder-date');
    localStorage.removeItem('reminder-time');
    localStorage.removeItem('reminder-text');
    this.reminder.text = '';
    this.pomodoroRepository.dateData = '';
    this.resetForm();
  }
  }

  getListOfReminder(): any {
    this.reminderService.reminderList().subscribe(
      (data) => {
        this.reminders = data.data;
        localStorage.setItem('reminders', JSON.stringify(this.reminders));
      }
    );
  }

  storeReminder(reminder): any {
    this.reminderService.storeReminder(reminder).subscribe(
      (data) => {
        this.getListOfReminder();
      }
    );
  }

  detailReminder(id): any {
    this.reminderService.reminderDetail(id).subscribe();
  }

  deleteReminder(id): any {
    this.reminderService.deleteReminder(id).subscribe(
      (data) => {
        this.getListOfReminder();
        this.snackBar.showSnackBar( 'پیامک یادآوری با موفقیت حذف شد.', 'red-snackbar');
      }
    );
  }

  updateReminder(reminder): any {
    this.sendReminder.content = this.editContent;
    const jalaliDate = reminder.jalali_send_date;
    this.sendReminder.send_date = jalaliDate.concat(':00');
    this.reminderService.updateReminder(this.sendReminder).subscribe(
      (data) => {
        reminder.is_edit = false;
        this.getListOfReminder();
        this.snackBar.showSnackBar('متن پیامک یادآوری با موفقیت به روز رسانی شد.', 'green-snackbar');
      }, (err) => {
        const errorFromServer = err.error;
        if (Object.keys(errorFromServer)[0] === 'content'){
          this.snackBar.showSnackBar( errorFromServer.content[0], 'red-snackbar');
        }
      }
    );
  }

  showEditMode(reminder): any {
    // this.editMode = !this.editMode;
    reminder.is_edit = !reminder.is_edit;
    localStorage.setItem('reminderEditId', reminder.id);
    this.editContent = reminder.content;
  }

  backToNoneEditMode(reminder): any {
    reminder.is_edit = false;
  }

  archiveReminder(reminder): any {
    reminder.archive = true;
    this.snackBar.showSnackBar('پیامک یادآوری  با موفقیت به لیست پیام های آرشیو شده اضافه شد.', 'green-snackbar');
    localStorage.setItem('reminderArchiveId', reminder.id);
    setTimeout(() => {
      this.reminderService.archiveReminder().subscribe();
    }, 500);
  }

  resetForm(): any {
    this.fromInput.value = '';
  }
  navigateToArchive(): any{
    this.router.navigateByUrl('/reminder/archives').then();
  }
  getCurrentUser(): any{
    this.userService.getCurrentUserInfo().subscribe(
      (data) => {
        if (data.mobile === null){
          this.haveMobile = false;
        } else {
          this.haveMobile = true;
        }
      }
    );
  }
  openMobileDialog(): any{
    this.dialog.open(ReminderSetMobileComponent);
  }
}
